export default __webpack_public_path__ + "static/media/cute-family-taking-hot-drink-winter-field.eb2457ae.jpg";